import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import UploadHistoryList from '../../doc-upload-history';
import UploadHistoryListHeader from '../../doc-upload-history-list-header';
import UploadHistorySearch from '../../doc-upload-history-search';
import Spinner from '@dbk/ui-spinner';
import take from 'lodash/take';
import BlurModal from '../../../../components/common/blur-modal';
import { NotificationWarning } from '@dbk/ui-icons';
import { DOC_UPLOAD } from '../../../../constants';
import DocuploadPreview from '../doc-upload-preview';
import moment from 'moment';
import $ from 'npm-zepto';

class UploadHistory extends PureComponent {
    constructor(props) {
        super(props);
        const currentDate = moment();
        const lastMonth = moment().add(-2, 'year');

        this.state = {
            recordListOffset: 0,
            recordListLimit: 10,
            loadMore: false,
            recordOffsetLimit: 0,
            sortColumn: 'createdTs',
            order: 'desc',
            modalVisible: false,
            documentId: null,
            docName: null,
            pdfByteStream: '',
            downloadInProgress: false,
            extType: '',
            documentType: '',
            downloading: false,
            viewDoc: false,
            docId: null,
            value: {
                from: lastMonth,
                to: currentDate
            },
            filterObj: {
                bpId: [],
                contract: [],
                dateRange: { from: lastMonth, to: currentDate },
                isSelf: false,
                name: []
            },
            page: {
                pageNumber: 0,
                recordSize: 10
            }
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
        const { docupload: { getUploadHistory } } = this.props;
        getUploadHistory(this.state.sortColumn, this.state.order, this.state.filterObj, this.state.page);
    }

    componentWillReceiveProps(nextProps){
        const { downloadedBase64, docId, downloaded: { fileName, fileType } } = this.props.docupload;
        if(nextProps.docupload.downloadedBase64 !== downloadedBase64 && this.state.downloading){
            this.downloadPDF(nextProps.docupload.downloadedBase64, this.state.docName, this.state.documentType);
        }
    }

    // componentDidUpdate(prevProps, nextProps) {
    //     const { downloadedBase64, downloaded: { fileName, fileType } } = this.props.docupload;
    //     if (prevProps.docupload.downloadedBase64 !== downloadedBase64 && this.state.downloading) {
    //         this.downloadPDF(downloadedBase64, fileName, fileType);
    //     }
    // }

    onScroll = () => {

        if ($(document).height() === $(window).scrollTop()+$(window).height()) {
            const count = this.state.recordListLimit + 10;
            const data = this.props.docupload.historyRecordDetails;
            const recordListLimit = this.state.recordListLimit;
            const recordOffsetLimit = (data !== null && data.length - recordListLimit > 10) ?
                recordListLimit : data.length;
            if (data !== null && data.length > 0) {
                if (data && data.length === recordOffsetLimit) {
                    const page = {
                        pageNumber: this.state.page && this.state.page.pageNumber + 1 || 0,
                        recordSize: 10
                    }
                    if (this.props.docupload.uploadHistory.pagination.lastPage !== true) {
                        this.setState({ loadMore: true, page: { pageNumber: page.pageNumber, recordSize: page.recordSize } });
                        this.props.docupload.getUploadHistory(this.state.sortColumn, this.state.order, this.state.filterObj, page);
                    } else {
                        this.setState({ loadMore: false });
                    }
                }
            }
            if (data && data.length > recordListLimit) {
                this.setState({ recordListLimit: count, loadMore: true });
            }
        }
    }

    getDataForRendering = () => {
        const data = this.props.docupload.historyRecordDetails;
        const recordListLimit = this.state.recordListLimit;
        if (data !== null) {
            const recordOffsetLimit = (data.length - recordListLimit > 20) ?
                recordListLimit : data.length;
            if (data && data.length >= recordOffsetLimit) {
                return take(data, recordOffsetLimit);
            }
            return data;
        }
        return null;
    }

    onSearchClick = (data, page) => {
        const { docupload: { getUploadHistory, setHistoryRecordDetails } } = this.props;
        setHistoryRecordDetails([]);
        this.setState({
            filterObj: data,
            page
        })
        getUploadHistory(this.state.sortColumn, this.state.order, data, page);
    }


    renderSortArrow = (selectedColumn) => {
        let className = '';
        if (this.state.sortColumn === selectedColumn) {
            className = (this.state.order === DOC_UPLOAD.ORDER_DESC) ? 'arrow-down' : 'arrow-up';
        }
        if (!className) {
            className = ''
        }
        return (
            <span className={className} />
        );
    }

    onSortClick = (currentSortColumn) => {
        let sortOrder = this.state.order;
        const page = {
            pageNumber: 0,
            recordSize: 10
        }

        if (this.state.sortColumn === currentSortColumn) {
            sortOrder = (sortOrder === DOC_UPLOAD.ORDER_ASC ?
                DOC_UPLOAD.ORDER_DESC : DOC_UPLOAD.ORDER_ASC);
        } else {
            sortOrder = DOC_UPLOAD.ORDER_DESC;
        }
        this.setState({
            order: sortOrder,
            sortColumn: currentSortColumn,
            loadMore: false,
            page
        });
        if (this.props.docupload.historyRecordDetails.length > 0) {
            this.props.docupload.setHistoryRecordDetails([]);
            this.props.docupload.getUploadHistory(currentSortColumn, sortOrder, this.state.filterObj, page);
        }
    }

    renderSortArrow(selectedColumn) {

        let className = '';
        if (this.state.sortColumn === selectedColumn) {
            className = (this.state.sort.direction === DOC_UPLOAD.ORDER_DESC) ? 'arrow-down' : 'arrow-up';
        }

        if (!className) {
            className = ''
        }
        return (
            <span className={className} />
        );
    }
    closePdf = () => {
        this.setState({ documentId: null });
    }

    downloadPDF(pdf, docName, fileType) {
        const linkSource = `data:${fileType};base64,${pdf}`;
        const downloadLink = document.createElement("a");
        const fileName = docName;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.setState({
            downloading: false,
            viewDoc: false
        })
    }

    closeBlurModelPreview = () => {
        if (this.state.documentId != null) {
            return;
        }
        this.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '' });
    }

    onViewDocClick = (docId, docuSafeId, contract) => {

        const { docupload: { setSpinner } } = this.props;
        
        if (this.detectIE()) {
            this.onDownloadClick(docId, docuSafeId, contract);
        } else {
            if (this.state.docId !== docId) {
                setSpinner(true);
                const ViewOnly = true;
                this.downloadBinarydata(docId, docuSafeId, contract, ViewOnly);
            }
             else {
                this.setState({
                    modalVisible: true, docName: this.props.docupload.downloaded.fileName,
                    pdfByteStream: '', extType: '', documentType: this.props.docupload.downloaded.contentType, viewDoc: true, docId
                })
            }
            this.setState({docId: docId}, ()=> console.log("XYZ docid", docId));
        }
    }

    downloadBinarydata(docId, docuSafeId, contract, ViewOnly){

        const { docupload: { setSpinner, setDownloadedBase64,  setDownloadedFileName,  setDownloadedFileType, setBlurModalError }, settings: { currentEnvironment: { remoteUrl } } } = this.props;

        const requestBody = {
            adminUserId:this.props.auth.userId,
            docMetadataId:docId,
            docusafeDocId:docuSafeId,
            contract
          }
          const RSA_URL = remoteUrl +'/rmaccess/' + this.props.app.config.apiverion + '/download'; // PROD
        
          const req = new XMLHttpRequest();
          req.open('POST', RSA_URL);
          req.setRequestHeader('Authorization-Token', this.props.auth.authHeader);
          // Enable for local testing
          //req.setRequestHeader('Authorization','Bearer cb7fe76d4f13fdfdac7028d9950ff9c9');
          req.setRequestHeader('Content-Type', "application/json");
          req.send(JSON.stringify(requestBody));
          req.onload = function (e) {
            try {
             // setDocuploadLoading(false);
              if (req.status === 200) {
                const jsonResponse = JSON.parse(req.responseText);
                if (jsonResponse.retCode === "0") {
                    setSpinner(false);
                  if (jsonResponse && jsonResponse.data) {
                     setDownloadedBase64(jsonResponse.data || "");
                     setDownloadedFileName(jsonResponse.fileName);
                     setDownloadedFileType(jsonResponse.contentType);
                  } else {
                    //setBlurModalError(true)
                  }
                  if(ViewOnly){
                    this.setState({
                        modalVisible: true, 
                        docName: jsonResponse.fileName,
                        pdfByteStream: '', 
                        extType: '', 
                        documentType: jsonResponse.contentType, 
                        viewDoc: true, 
                        docId
                    })
                  }
                  if(!ViewOnly){
                    this.setState({ downloading: true, docId, documentType: jsonResponse.contentType, docName: jsonResponse.fileName });
                  }
                }
              }
              else {
                setBlurModalError(true)
              }
            }
            catch (error) {
              setBlurModalError(true)
            }
        }.bind(this)
    }

    onDownloadClick = (docId, docuSafeId, contract) => {
        const { documentDownload, downloadedBase64, setSpinner, downloaded: { fileName, fileType } } = this.props.docupload;
        
        if (this.state.docId !== docId) {
            setSpinner(true);
            const ViewOnly = false;
            this.downloadBinarydata(docId, docuSafeId, contract, ViewOnly);
        } else {
            this.downloadPDF(downloadedBase64, fileName, fileType);
        }


    }

    detectIE = () => {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE '); // IE 10 or older => return version number
        const trident = ua.indexOf('Trident/'); // IE 11 => return version number
        const edge = ua.indexOf('Edge/'); // IE 12 => return version number
        if (msie > 0 || trident > 0 || edge > 0) {
            return true;
        }
        return false;
    }

    closeBlurModel = () => {
        this.props.docupload.setBlurModalError(false);
    }

    renderErrorModal = () => {
        const { docupload: { showErrorModal, errorTitle, errorMsg } } = this.props;

        return (
            <BlurModal
                visible={showErrorModal}
                doneVisible={false}
                title={<h4>{errorTitle}</h4>}
                onDone={() => this.closeBlurModel()}
            >
                <div className="error-message-container">
                    <NotificationWarning color='#b92635' className="error-icon" width={25} height={25} />
                    <span className="error-message-content">{errorMsg}</span>
                </div>
            </BlurModal>
        )
    }

    componentWillUnmount() {
        this.props.docupload.setHistoryRecordDetails([]);
        window.removeEventListener('scroll', this.onScroll);
    }

    render() {
        const { i18n: { messages }, docupload: { showErrorModal, search: { showSpinner }, downloaded: { fileName }, downloadedBase64 } } = this.props;
        const data = this.getDataForRendering();
        return (
            <div>
                <div className="columns large-12">
                    <div className="columns large-2">
                        <UploadHistorySearch onSearchHandle={this.onSearchClick} />
                    </div>
                    <div className="columns large-10" style={{ marginTop: '40px' }}>
                        <div className="data-container">
                            <UploadHistoryListHeader onSortClick={this.onSortClick} renderSortArrow={this.renderSortArrow} />
                            {/* {showSpinner && <div className="columns large-2 large-centered">
                                <Spinner testID="spinner_contractList_loading_test"
                                    accessibilityLabel="spinner_contractList_loading_test" /></div>}  */}
                            {data.length > 0 &&
                                <div id="scrollView" className="data-wrapper columns large-8 medium-12 small-12">
                                    {Object.keys(data).map((item, index) =>
                                        <UploadHistoryList
                                            data={data[item]}
                                            onViewDocClick={this.onViewDocClick}
                                            onDownloadClick={this.onDownloadClick} />)}
                                </div>}
                            {showSpinner && <div className="columns large-2 center-content pad-top-15">
                                <Spinner size="large" className="doc-upload-history-spinner" testID="spinner_contractList_loading_test"
                                    accessibilityLabel="spinner_contractList_loading_test" /></div>}
                        </div>
                    </div>
                    {showErrorModal && this.renderErrorModal()}
                </div>
                {downloadedBase64 &&
                    <DocuploadPreview
                        screen={screen}
                        modalVisible={this.state.modalVisible}
                        doneLabel="Close"
                        onCloseBlurModel={this.closeBlurModelPreview}
                        headerLabel={fileName}
                        closePdf={this.closePdf}
                        pdfData={downloadedBase64}
                        messages={messages}
                        pdfDataDownloadInProgress={this.state.downloadInProgress}
                        extType={this.state.extType}
                        documentType={this.state.documentType}
                    />

                }
            </div>
        );
    }

}
export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        app: {
            config: {
                apiverion: true
            },
        },
        auth: {
            userId: true,
            authHeader: true,
        },
        settings: {
            currentEnvironment: {
              remoteUrl: true,
            },
        },
        docupload: {
            historyRecordDetails: true,
            setHistoryRecordDetails: { $set: 'historyRecordDetails' },
            search: { showSpinner: true },
            errorMsg: true,
            getUploadHistory: { $call: 'getUploadHistory' },
            uploadHistory: { pagination: true },
            showErrorModal: true,
            errorTitle: true,
            setBlurModalError: { $set: 'showErrorModal' },
            documentDownload: { $call: 'documentDownload' },
            downloadedBase64: true,
            finalizeSuccess: true,
            downloaded: { fileName: true, fileType: true },
            setDownloadedBase64: { $set: 'downloadedBase64'},
            setDownloadedFileName: { $set: 'downloaded.fileName'},
            setDownloadedFileType: { $set: 'downloaded.fileType'},
            setSpinner: { $set: 'search.showSpinner'},

        }
    },
})(UploadHistory);
